import React from 'react';
import './ErrorModal.css';

interface ErrorModalProps {
  isOpen: boolean;
  error: string;
  onClose: () => void;
  onGoToApp: () => void;
}

const ErrorModal: React.FC<ErrorModalProps> = ({ isOpen, error, onClose, onGoToApp }) => {
  if (!isOpen) return null;

  const handleBackClick = () => {
    if (window.history.length > 1) {
      window.history.back();
    } else {
      // If no history, go to the main domain
      window.location.href = 'https://app.fiestalbum.com';
    }
  };

  const handleGoToAppClick = () => {
    window.location.href = 'https://app.fiestalbum.com';
  };

  return (
    <div className="error-modal-overlay">
      <div className="error-modal">
        <div className="error-modal-header">
          <h2>Event Not Found</h2>
        </div>
        
        <div className="error-modal-content">
          <div className="error-icon">⚠️</div>
          
          <div className="error-message">
            {error.includes('No event code') ? (
              <p>Missing event code in URL</p>
            ) : error.includes('HTTP error! status: 500') ? (
              <p>Invalid event code</p>
            ) : (
              <p>Unable to load event</p>
            )}
          </div>
          
          <div className="error-suggestion">
            <p>Please check your event URL or contact the event organizer.</p>
          </div>
        </div>
        
        <div className="error-modal-actions">
          <button 
            className="error-btn error-btn-secondary" 
            onClick={handleBackClick}
          >
            Go Back
          </button>
          <button 
            className="error-btn error-btn-primary" 
            onClick={handleGoToAppClick}
          >
            Go to FiestAlbum
          </button>
        </div>
      </div>
    </div>
  );
};

export default ErrorModal;

